import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const popover: SxStyle = {
  '.MuiPaper-elevation': {
    p: 0,
    width: (p) => p.spacing(55.5),
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (p) => p.palette.primary[500],
  },
};

export const content: SxStyle = {
  position: 'relative',
};

export const autoComplete: SxStyle = {
  position: 'relative',
  '.MuiOutlinedInput-root': {
    pl: (p) => p.spacing(5),
  },
};

export const iconWrapper: SxStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  pl: (p) => p.spacing(1),
  color: (p) => p.palette.primary[500],
};
